import { Grid } from '@mui/material';
import type { MultiProductBannerOfferType } from '@repo/supergraph-schemas/marketplace/multiProductBanner/types';
import { ProductCard } from './ProductCard';

type Props = {
  highlightColor?: string;
  highlightTextColor?: string;
  impressionSection?: string;
  offers: MultiProductBannerOfferType[];
  isAdBanner?: boolean;
};

export const ProductCards = ({
  highlightColor = 'blues.lightest',
  highlightTextColor = 'blues.main',
  impressionSection = 'multi_product_banner',
  offers,
}: Props) => {
  return (
    <Grid container sx={{ gap: { xs: 3, lg: 3.5 }, flexWrap: { sm: 'unset' }, width: '100%' }}>
      {offers.map((offer, index) => (
        <Grid size={{ xs: 12, sm: 4 }} key={offer.id}>
          <ProductCard
            highlightColor={highlightColor}
            highlightTextColor={highlightTextColor}
            impressionSection={impressionSection}
            impressionPosition={index}
            marketplaceEntity={offer}
          />
        </Grid>
      ))}
    </Grid>
  );
};
